export default {
  statusMap: {
    0: { title: '未授权' },
    1: { title: '已授权' },
    2: { title: '已禁止' }
  },
  auditStatusMap: {
    0: { title: '待审核' },
    1: { title: '审核通过' },
    2: { title: '审核失败' }
  }
}



// WEBPACK FOOTER //
// ./src/global/userConfig.js